import './mosaic-gallery.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMosaicGallery = (context) => {
  const mosaicGallerySection = context.closest('.shopify-section');
  if (!mosaicGallerySection) return;

  const fixedGallery = mosaicGallerySection.querySelector('.mosaic-gallery__fixed-wrapper');
  if (fixedGallery) {
    const swiperContainer = fixedGallery.querySelector('.mosaic-gallery__fullscreen-gallery');
    if (swiperContainer) {
      const swiper = new Swiper(swiperContainer, {
        loop: false,
        navigation: {
          prevEl: mosaicGallerySection.querySelector('.mosaic-gallery__arrow--left'),
          nextEl: mosaicGallerySection.querySelector('.mosaic-gallery__arrow--right')
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false
        }
      });

      fixedGallery.addEventListener('keyup', (e) => {
        if (e.code && e.code === 'Escape') {
          document.querySelector('html').style.overflow = '';
          document.querySelector('body').style.overflow = '';
          fixedGallery.classList.remove('open');
          fixedGallery.blur();
        }
      });

      const closeIcon = fixedGallery.querySelector('.mosaic-gallery__close-icon');
      closeIcon.addEventListener('click', () => {
        document.querySelector('html').style.overflow = '';
        document.querySelector('body').style.overflow = '';
        fixedGallery.classList.remove('open');
        fixedGallery.blur();
      });

      const mosaicImages = mosaicGallerySection.querySelectorAll('.mosaic-gallery__image');
      if (mosaicImages.length > 0) {
        mosaicImages.forEach(image => {
          image.addEventListener('click', () => {
            if (image.dataset.imageIndex) {
              swiper.slideTo(image.dataset.imageIndex, 0);
            }
            document.querySelector('html').style.overflow = 'hidden';
            document.querySelector('body').style.overflow = 'hidden';
            fixedGallery.classList.add('open');
            fixedGallery.focus();
          });
        });
      }
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.mosaic-gallery__container'), (el) => {
    window.dAgency.initMosaicGallery(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.mosaic-gallery__container'), (el) => {
      window.dAgency.initMosaicGallery(el);
    });
  });
}
